import PropTypes from "prop-types";
import { intlMessageShape } from "./intlMessageShape";
export var lookupOptionTypeShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  displayName: intlMessageShape.isRequired,
  className: PropTypes.string
});